import { observable, action } from "mobx";

export type MasterEventTypeInitial = {
    eventName: string
    id: string;
    team1Name: string;
    team2Name: string;
    leagueID: string;
    leagueName: string;
    eventDate: string;
    eventTime: string;
    sportID: string;
    sportName: string;
    isTeamSwapEnabled: boolean;
    regionId: string;
    eventDateTime: string;
};

export class MasterEventInitialData {

    @observable eventDate: string;
    @observable eventTime: string;

    eventName: string;
    id: string;
    team1Name: string;
    team2Name: string;
    leagueID: string;
    leagueName: string;
    sportID: string;
    sportName: string;
    isTeamSwapEnabled: boolean;
    eventDateTime: string;
    regionId: string;

    constructor(masterEventData: MasterEventTypeInitial) {
        this.eventName = masterEventData.eventName;
        this.id = masterEventData.id;
        this.team1Name = masterEventData.team1Name;
        this.team2Name = masterEventData.team2Name;
        this.leagueID = masterEventData.leagueID;
        this.leagueName = masterEventData.leagueName;
        this.eventDate = masterEventData.eventDate;
        this.eventTime = masterEventData.eventTime;
        this.sportID = masterEventData.sportID;
        this.sportName = masterEventData.sportName;
        this.isTeamSwapEnabled = masterEventData.isTeamSwapEnabled;
        this.eventDateTime = masterEventData.eventDateTime;
        this.regionId = masterEventData.regionId;
    }

    @action.bound
    updateDateTime(formattedDate: string, formattedTime: string): void {
        this.eventDate = formattedDate;
        this.eventTime = formattedTime;
    }
}
